import { RouteObject } from 'react-router-dom';
import GuardRoute from '@/components/GuardRoute';
import { AgnosticIndexRouteObject, AgnosticNonIndexRouteObject } from '@remix-run/router';
import * as React from 'react';

export interface IndexRouteObject {
  caseSensitive?: AgnosticIndexRouteObject['caseSensitive'];
  path?: AgnosticIndexRouteObject['path'];
  id?: AgnosticIndexRouteObject['id'];
  loader?: AgnosticIndexRouteObject['loader'];
  action?: AgnosticIndexRouteObject['action'];
  hasErrorBoundary?: AgnosticIndexRouteObject['hasErrorBoundary'];
  shouldRevalidate?: AgnosticIndexRouteObject['shouldRevalidate'];
  handle?: AgnosticIndexRouteObject['handle'];
  index: true;
  children?: undefined;
  element?: React.ReactNode | null;
  errorElement?: React.ReactNode | null;
  auth?: string | boolean;
}
export interface NonIndexRouteObject {
  caseSensitive?: AgnosticNonIndexRouteObject['caseSensitive'];
  path?: AgnosticNonIndexRouteObject['path'];
  id?: AgnosticNonIndexRouteObject['id'];
  loader?: AgnosticNonIndexRouteObject['loader'];
  action?: AgnosticNonIndexRouteObject['action'];
  hasErrorBoundary?: AgnosticNonIndexRouteObject['hasErrorBoundary'];
  shouldRevalidate?: AgnosticNonIndexRouteObject['shouldRevalidate'];
  handle?: AgnosticNonIndexRouteObject['handle'];
  index?: false;
  children?: RouteDefine[];
  element?: React.ReactNode | null;
  errorElement?: React.ReactNode | null;
  auth?: string | boolean;
}

export declare type RouteDefine = IndexRouteObject | NonIndexRouteObject;

export const createRoute = (route: RouteDefine[]) => {
  return transform(route);
};

function transform(route: RouteDefine[] | undefined): RouteObject[] {
  if (route === undefined) {
    return [];
  }
  return route.map(it => {
    const { auth, ...define } = it;
    const child = transform(it.children);
    if (child && child.length > 0) {
      define.children = child;
    } else {
      define.children = undefined;
    }
    if (auth === undefined) {
      return define;
    }
    define.element = <GuardRoute permission={auth}>{define.element}</GuardRoute>;
    return define;
  });
}
